var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-dropzone',{staticClass:"mt-3",attrs:{"id":"dropzone","options":_vm.dropzoneOptions,"useCustomDropzoneOptions":true},on:{"vdropzone-sending":_vm.addFormData,"vdropzone-success":_vm.getSuccess}})}
var staticRenderFns = []

export { render, staticRenderFns }